export const SSO_PROVIDER_GOOGLE = 'sso-provider-google';
export const SSO_PROVIDER_DISCORD = 'sso-provider-discord';
